enum MonitorPrivacy {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  READ_ONLY = 'READ_ONLY',
}

export default MonitorPrivacy;
